import Actions             from 'Redux/Actions';
import { SettingsRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from }            from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findSettingsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findSettingsRequest.type),
    mergeMap(action => from(
      SettingsRepository.findAllOptions()
        .then(({ options }) => Actions.findSettingsSuccess({ options }))
        .catch((error: Error) => Actions.findSettingsFailure({ error })),
    )),
  );
};
